import React from 'react'
import { mobile } from './tokens'

interface MobilePageProps {
  children: React.ReactNode
  className?: string
  tight?: boolean
}

/** Consistent page padding / spacing for mobile shell + desktop. */
export function MobilePage({ children, className = '', tight }: MobilePageProps) {
  return (
    <div className={`${tight ? mobile.pageTight : mobile.page} ${className}`.trim()}>
      {children}
    </div>
  )
}
